import { Timestamp } from "firebase/firestore";

export type StudentDetailSchema = {
    StripeCustomerId: string;
    PreferedContactEmail: string;
    PreferedContactPhone: string;
    UserGuideCompleted: boolean;
    StudentTOS: StudentTOS;
};

export type StudentTOS = {
    date_created: Timestamp,
    date_updated: Timestamp,
    date_user_agreed_on: Timestamp,
};

const nameofStudentDetailSchemaCollection = "StudentDetail";
const nameofStudentDetailSchemaStripeCustomerId = "StripeCustomerId";
const nameofStudentDetailSchemaPreferedContactEmail = "PreferedContactEmail";
const nameofStudentDetailSchemaPreferedContactPhone = "PreferedContactPhone";
const nameofStudentDetailSchemaUserGuideCompleted = "UserGuideCompleted";

const nameofStudentDetailSchemaStudentTOS = "StudentTOS";
const nameofStudentTOSDateCreated = "date_created";
const nameofStudentTOSDateUpdated = "date_updated";
const nameofStudentTOSDateUserAgreedOn = "date_user_agreed_on";

export {
    nameofStudentDetailSchemaCollection,
    nameofStudentDetailSchemaStripeCustomerId,
    nameofStudentDetailSchemaPreferedContactEmail,
    nameofStudentDetailSchemaPreferedContactPhone,
    nameofStudentDetailSchemaUserGuideCompleted,
    nameofStudentDetailSchemaStudentTOS,
    nameofStudentTOSDateCreated,
    nameofStudentTOSDateUpdated,
    nameofStudentTOSDateUserAgreedOn,
}

export type StudentDetailView = StudentDetailSchema & {
    Id: string;
}